/* eslint-disable max-len */
export default {
    common: {
        insert: 'Inserisci',
        edit: 'Modifica',
        continue: 'Continua',
        back: 'Indietro',
        save: 'Salva',
        delete: 'Elimina',
        search: 'Cerca',
        abort: 'Annulla',
        cancel: 'Cancella',
        warning: 'Attenzione!',
        ok: 'OK',
        confirm: 'Conferma',
        errors: {
            general: 'Ops qualcosa è andato storo, riprova più tardi',
        },
    },
    card: {
        regions: 'Regioni',
        countries: 'Nazioni',
        zones: 'Province',
        categories: 'Categorie',
        subcategories: 'Sottocategorie',
        search: 'Ricerca #',
        country: 'Nazione',
        italy: 'Italia',
        addNew: 'Aggiungi una nuova ricerca',
        searchResult: 'Sono state trovate {0} anagrafiche',
        searchCounts: 'Cerca anagrafiche',
        requestQuote: 'Richiedi preventivo',
        createQuote: 'Crea preventivo',
    },
    estimator: {
        title: 'Seleziona fino a 3 ricerche',
    },
    search: {
        filterRegions: 'Filtra per Regioni',
        filterCountries: 'Filtra per Nazioni',
        filter: 'Filtra per ',
        country: 'Nazioni',
        zone: 'Province',
        category: 'Categorie',
        subcategory: 'Sottocategorie',
        italy: 'ITALIA',
        abroad: 'ESTERO',
        selectOptions: 'Seleziona una o più opzioni per restringere la tua ricerca.',
        selectAll: 'Per selezionarle tutte clicca su Continua',
    },
    quote: {
        invoiceData: 'Compila i dati fiscali:',
        noInvoiceData: 'Non sono presenti dati di fatturazione, aggiungili per proseguire con l\'acquisto.',
        company: 'Azienda:',
        emailCompany: 'Email aziendale:',
        vatValue: 'Partita IVA:',
        quoteDetail: 'Dettaglio preventivo',
        contactsCount: 'Totale anagrafiche:',
        unitPrice: 'Prezzo unitario:',
        discount: 'Sconto:',
        totalPriceDiscounted: 'Totale scontato:',
        totalPriceDiscountedWithTax: 'Totale scontato con Iva:',
        subtotal: 'Subtotale:',
        vat: 'Iva:',
        total: 'Totale:',
        sendQuoteByEmail: 'Invia preventivo via email',
        finalizeQuote: 'Procedi',
        contactLimit: 'Limite contatti:',
        promoCode: 'Codice promo:',
        minPriceApplied: 'Prezzo minimo applicato:',
        foreignPriceId: 'ForeignPriceId:',
        fileName: 'Nome del file:',
        fileStatus: 'Status del file:',
        soldContactsStatus: 'Status inserimento contatti venduti:',
        foreignPaymentId: 'ForeignPaymentId:',
        noPurchased: 'Nessun Acquisto',
        manualPurchase: 'Manuale',
        purchasedAt: 'Data processo acquisto:',
        purchaseType: 'Tipologia acquisto:',
        searchQuery: 'Query di ricerca:',
        fileStatusEnum: {
            completed: 'Completato',
            processing: 'In creazione',
            interrupt_due_errors: 'Errore',
            null: '',
        },
        soldContactsStatusEnum: {
            completed: 'Completato',
            processing: 'In corso',
            interrupt_due_errors: 'Errore',
            null: '',
        },
        downloadContacts: 'Download contatti',
        manualFinalize: 'Finalizzazione manuale',
    },
    fiscalData: {
        invoiceData: 'Dati di fatturazione:',
        vatValue: 'Identificativo Fiscale',
        fiscalCode: 'Codice Fiscale',
        fiscalCodePlaceholder: 'Codice Fiscale',
        electronicInvoice: 'Fatturazione elettronica*',
        fillOneField: 'Compila almeno uno dei due campi',
        pec: 'PEC',
        sdi: 'SDI',
        companyData: 'Dati aziendali',
        companyEmail: 'Email Aziendale*',
        vat: 'Partita IVA*',
        phone: 'Telefono',
        phonePlaceholder: 'Telefono es. +393333333333*',
        companyName: 'Nome Azienda*',
        country: 'Nazione*',
        city: 'Città*',
        zone: 'Provincia*',
        zip: 'CAP*',
        address: 'Indirizzo*',
        civicNumber: 'N° civico',
        requiredFields: '*Campi obbligatori',
        noResult: 'nessun risultato',
    },
    userData: {
        fillData: 'Inserisci i tuoi dati',
        email: 'Email',
        emailRequired: 'Email*',
        firstName: 'Nome',
        lastName: 'Cognome',
        phone: 'Telefono',
        phonePlaceholder: 'es. +393333333333',
        countsLimit: 'Limite Anagrafiche',
        addLimit: 'Voglio inserire un limite massimo di anagrafiche nel mio preventivo',
        has4demLabel: 'Account 4Dem',
        has4dem: 'Ho un account 4Dem',
        requiredFields: '*Campi obbligatori',
        calculateQuote: 'Calcola preventivo',
    },
    quoteError: {
        title: 'Il tuo acquisto non è andato a buon fine',
        description: 'Ti invitiamo a riprovare in un secondo momento.',
    },
    errors: {
        default: 'Errore durante l\'acquisto manuale',
        QuoteIsObsolete: 'Non puoi finalizzare l\'acquisto, Il preventivo è obsoleto',
        QuoteAlreadyPurchased: 'Non puoi finalizzare l\'acquisto, Il preventivo è già stato acquistato',
    },
    quoteSuccess: {
        title: 'Il tuo acquisto è stato completato',
        description: 'A breve riceverai una e-mail con le anagrafiche acquistate.',
        button: 'Crea un nuovo preventivo',
    },
    oblio: {
        emailName: 'email',
        emailCTA: 'Invia',
        contactAs: 'Contattaci',
        emailLabel: 'Inserisci la tua email',
        emailPlaceholder: 'Inserisci il tuo indirizzo email',
        title: 'Verifica la presenza dei tuoi dati all\'interno del database di Mailtogo.',
        foundResult: 'Ti confermiamo di aver trovato il tuo indirizzo email nel tuo nostro database, contattaci per richiedere la rimozione o ulteriori informazioni:',
        notFoundResult: 'L\'indirizzo email non è presente nel nostro database. Se vuoi maggiori informazioni contattaci:',
        text: 'Se pensi che la nostra azienda abbia dei dati personali e vuoi esercitare il diritto previsto dal GDPR inserisci qui l\'indirizzo email.',
    },
    login: {
        email: 'Email',
        password: 'Password',
        role: 'Ruolo',
        unuthorizedMessage: 'Email o password errati',
        backToEstimator: 'Torna al preventivatore',
        login: 'Login',
    },
    roles: {
        admin: 'Amministratore',
        sale: 'Commerciale',
        customer: 'Cliente',
    },
    userQuotes: {
        title: 'Preventivi',
    },
    tableFields: {
        name: 'Nome',
        lastName: 'Cognome',
        email: 'Email',
        phone: 'Telefono',
        company: 'Azienda',
        vat: 'Partita IVA',
        contacts: 'Contatti',
        price: 'Prezzo',
        purchased: 'Acquistato',
        createdAt: 'Data Creazione',
        purchasedAt: 'Data Acquisto',
        fileStatus: 'File',
        actions: 'Azioni',
        soldContactsStatus: 'Stato inserimento contatti acquistati',
        min: 'Min',
        max: 'Max',
    },
    quotesTable: {
        quotesPurchased: 'Preventivi acquistati',
        quoteUniqueDays: 'Preventivi raggruppati per giorni',
        totalQuotes: 'Preventivi totali',
        leadCreated: 'Lead creato',
        filterByCreatedAt: 'Filtra per data di creazione',
        manualPurchase: '(manuale)',
        manualFinalize: 'Finalizzazione manuale',
        clear: 'Pulisci',
        perPage: 'Per pagina',
        name: 'Nome',
        lastName: 'Cognome',
        email: 'Email',
        phone: 'Telefono',
        company: 'Azienda',
        vat: 'Partita IVA',
        contacts: 'Contatti',
        price: 'Prezzo',
        purchased: 'Acquistato',
        createdAt: 'Data Creazione',
        purchasedAt: 'Data Acquisto',
        totalCreatedLeads: 'Lead creati totali',
        salesName: 'Commerciale',
        fileStatus: 'File',
        actions: 'Azioni',
        more: 'Altro',
        subTotal: 'Subtotale',
        total: 'Totale',
        iva: 'Iva',
        ivaCalc: 'Iva calcolata',
        discount: 'Sconto',
        soldContactsStatus: 'Stato inserimento contatti acquistati',
        manualExtractionMessage: 'Processo di acquisto manuale iniziato con successo, verrai avvisato al termine del processo',
        extract: 'Estrai',
        copyToClipboard: 'Copiato con successo',
        confirmDelete: 'Sei sicuro di voler eliminare il preventivo?',
        confirmManualPurchase: 'Proseguendo con l\'operazione le anagrafiche del preventivo verranno aggiunte tra le anagrafiche acquistate dall\'utente e l\'acquisto verrà finalizzato. L\'operazione non è reversibile. Sei sicuro di voler procedere?',
        errors: {
            default: 'Errore durante l\'acquisto manuale',
            generic: 'Qualcosa è andato storto, aggiorna la pagina o riprova in un secondo momento',
            QuoteIsObsolete: 'Non puoi finalizzare l\'acquisto, Il preventivo è obsoleto',
            UserHasIncompleteQuote: 'Non è possibile finalizzare il preventivo in questo momento perchè ne esiste già uno in fase di finalizzazione. Prova più tardi.',
            QuoteAlreadyPurchased: 'Non puoi finalizzare l\'acquisto, Il preventivo è già stato acquistato',
            QuoteAlreadyFinalized: 'Non puoi finalizzare l\'acquisto, Il preventivo è già stato acquistato',
            QuoteNotFound: 'Errore: Il preventivo non è stato trovato',
            Unauthorized: 'Errore: Non sei autenticato, ricarica la pagina',
        },
    },
    quotesDetail: {
        quoteNumber: 'Preventivo #',
        sendEmail: 'Sei sicuro di voler inviare il preventivo a questo indirizzo email?',
    },
    usersTable: {
        email: 'Email',
        name: 'Nome',
        lastName: 'Cognome',
        phone: 'Telefono',
        company: 'Azienda',
        vat: 'Partita IVA',
        actions: 'Azioni',
    },
    usersDetail: {
        usersList: 'Lista utenti',
        confirmDelete: 'Sei sicuro di voler eliminare questo contatto?',
    },
    dateRangePicker: {
        firstDay: 1,
        format: 'dd-mm-yyyy HH:mm:ss',
        applyLabel: 'Applica',
        cancelLabel: 'Annulla',
        daysOfWeek: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
        monthNames: ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'],
    },
    navbar: {
        dashboard: 'Dashboard',
        users: 'Utenti',
        quotes: 'Preventivi',
        prices: 'Prezzi',
        search: 'Nuova ricerca',
        banner: 'Banner',
        signOut: 'Sign Out',
    },
    selectUserFromAdmin: {
        title: 'Seleziona l\'utente a cui associare il preventivo',
        create: 'Crea utente',
        selected: 'Hai selezionato:',
        addLimit: 'Inserisci un limite di anagrafiche',
        insertUserData: 'Inserisci i dati dell\'utente',
        assign: 'Assegna',
    },
    checkboxCard: {
        title: {
            NA: 'Altre forme legali',
        },
    },
}
